export default "assets/images/HVE-a08526a5.png";